export default __webpack_public_path__ + "static/media/NunitoSans-ExtraBold.52a99d58.ttf";